import { render, staticRenderFns } from "./StagingMetricsSummary.vue?vue&type=template&id=4a4070fc&scoped=true&"
import script from "./StagingMetricsSummary.vue?vue&type=script&lang=js&"
export * from "./StagingMetricsSummary.vue?vue&type=script&lang=js&"
import style0 from "./StagingMetricsSummary.vue?vue&type=style&index=0&id=4a4070fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4070fc",
  null
  
)

export default component.exports